export enum DateTypeFilterEnum {
  all = 'all',
  week = 'week',
  month = 'month',
  currentMonth = 'currentMonth',
}
